import React, { Component } from "react";
import "./style.css";
class TrinityResultTableHeader extends Component {
  render() {
    return (
      <table className="trinity_result_table_header_box">
        <tbody>
          <tr>
            <td
              style={{
                borderLeft: 0,
                width: "32%",
                textAlign: "left",
                paddingLeft: "5px",
              }}
            >
              院校（专业）名
            </td>
            <td style={{ width: "8%" }}>计划</td>
            <td style={{ width: "8%" }}>裸分</td>
            <td
              style={{ width: "32%" }}
              dangerouslySetInnerHTML={{ __html: "26年<br>初审要求" }}
            ></td>
            <td
              style={{ borderRight: "0px", width: "20%" }}
              dangerouslySetInnerHTML={{ __html: "报名时间<br>校考时间" }}
            ></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default TrinityResultTableHeader;



// WEBPACK FOOTER //
// ./src/containers/Trinity/TrinityResult/components/TrinityResultTable/components/TrinityResultTableHeader/index.js